module.exports = __webpack_public_path__ + "media/loketpendaftaran4.396fc4c4.mp3";